export default __webpack_public_path__ + "static/media/notifications.a8f1d66e.svg";